videojs.addLanguage('ru', {
	"Skip after": "Пропустить через",
	"Skip advertisement": "Пропустить рекламу",
	"Advertisement": "Реклама",
	"Go to the advertiser's site": "Перейти на сайт рекламодателя"
});